var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","fill":"none"}},_vm.$listeners),[_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"m8.94 10-4.092 4.092 1.061 1.06 4.092-4.09 4.091 4.09 1.06-1.06-4.09-4.091 4.09-4.092-1.06-1.06-4.091 4.09-4.092-4.09-1.06 1.06z","clip-rule":"evenodd"}})])
}
var staticRenderFns = []

export default { render: render }